interface Koordinator {
  index: number;
  name: string;
  position: string;
  department: string;
  image: string;
}

interface Sponsor {
  name: string;
  url: string;
  image: string;
}

export const KoordinatorenData: Koordinator[] = [
  {
    index: 0,
    name: "Prof. Dr. W. Korte",
    position: "Senior Consultant und Guest Researcher Empa",
    department:
      "Zentrum für Labormedizin (ZLM), Hämostase und Hämophiliezentrum, St. Gallen",
    image: "/img/wolfgang_korte_grau_neu.jpg",
  },
  {
    index: 1,
    name: "Dr. Lukas Graf",
    position: "Chefarzt und CMO",
    department:
      "Zentrum für Labormedizin (ZLM), Hämostase- und Hämophiliezentrum, St. Gallen",
    image: "/img/lukas_graf_grau.png",
  },
  {
    index: 2,
    name: "Prof. Dr. C. von Heymann, DEAA",
    position: "Chefarzt und Ärztlicher Direktor",
    department:
      "Klinik für Anästhesiologie, Intensivmedizin, Notfallmedizin und Schmerztherapie, Vivantes Klinikum im Friedrichshain, Berlin",
    image: "/img/von_heymann_grau.png",
  },
  {
    index: 3,
    name: "Dr. L. Kaufner, MSc",
    position: "Oberarzt",
    department:
      "Klinik für Anästhesiologie mit Schwerpunkt operative Intensivmedizin, Charité – Universitätsmedizin Berlin, Campus Virchow Klinikum, Berlin",
    image: "/img/kaufner_grau.png",
  },
  {
    index: 4,
    name: "PD Dr. Klamroth",
    position: "Chefarzt",
    department:
      "Klinik für Innere Medizin Angiologie und Hämostaseologie, Vivantes Klinikum im Friedrichshain, Berlin",
    image: "/img/klamroth.png",
  },
  {
    index: 5,
    name: "Jacqueline Fiore",
    position: "Koordinatorin Workshop St.&nbsp;Gallen",
    department: "",
    image: "/img/fiore.jpg",
  },
];

export const SponsorenData: Sponsor[{}] = [
  // Diagnostika
  [
    // {
    //   name: "Dialine",
    //   url: "https://dialine.ch/",
    //   image: "/sponsoren/Dialine.jpg",
    // },
    {
      name: "DiaSorin",
      url: "https://www.diasorin.com/home/",
      image: "/sponsoren/diasorin-new.jpg",
    },
    // {
    //   name: "Takeda",
    //   url: "https://www.takeda.com/",
    //   image: "/sponsoren/takeda.png",
    // },
    {
      name: "Sysmex",
      url: "https://www.sysmex.ch",
      image: "/sponsoren/sysmex-new.jpg",
    },
    {
      name: "Axonlab",
      url: "https://www.axonlab.com/",
      image: "/sponsoren/axonlab.png",
    },
    {
      name: "Roche",
      url: "https://www.roche.com/",
      image: "/sponsoren/Roche.png",
    },
    {
      name: "Stago",
      url: "https://www.stago.com/",
      image: "/sponsoren/stago.png",
    },
    {
      name: "HART Biological",
      url: "https://www.hartbio.co.uk/",
      image: "/sponsoren/hart_biologicals.jpg"
    }
    // {
    //   name: "Viatris",
    //   url: "https://www.viatris.com/",
    //   image: "/sponsoren/OUS_Viatris_Logo_Verti_RGB.png",
    // },

    // {
    //   name: "Mitsubishi Tanabe Pharma",
    //   url: "https://www.mt-pharma.co.jp/",
    //   image: "/sponsoren/Mitsubishi-Tanabe-Pharma.jpg",
    // }
  ],

  // Therapeutika Gold
  [
    // {
    //   name: "AstraZeneca",
    //   url: "https://www.astrazeneca.com/",
    //   image: "/sponsoren/astra_zeneca.jpg",
    // },
    {
      name: "Novo Nordisk",
      url: "https://www.novonordisk.com/",
      image: "/sponsoren/novonordisk-new.jpg",
    },
    {
      name: "Swedish Orphan Biovitrum AG",
      url: "https://www.sobi.com/",
      image: "/sponsoren/sobi.png",
    },
    {
      name: "CSL Behring",
      url: "https://www.cslbehring.com/",
      image: "/sponsoren/csl_behring.jpg",
    },
    {
      name: "Sanofi",
      url: "https://www.sanofi.com/de/schweiz",
      image: "/sponsoren/SANOFI.jpg",
    }
  ],
];
